import React, { useState, useEffect } from 'react';
import "../styles/Settings.css";
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import Error from  '../common/components/ErrorMessage'
import Success from  '../common/components/SuccessMessage'
import SingleBadge from '../common/components/SingleBadge'; // Adjust the import path as needed
import DataLine from '../common/components/DataLine'; // Adjust the path if necessary
import Fetch  from '../services/fetchService';
import AuthData from '../common/AuthData';
import { SETTINGS_API } from '../common/ResourcePaths'; // Import the constants
import Post from '../services/postService';
import YesNoPopup from '../common/components/YesNoPopup';

const Notifications = () => {
  const [mails, setMails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successTimer, setSuccessTimer] = useState(10);
  const [loader, setLoader] = useState(false);
  const [modified, setModified] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // State for popup visibility

  useEffect(() => {
    // Fetch the list of mails when the component mounts
    fetchMailingList();
  }, []);

  const fetchMailingList = async () => {
    try {
              setLoader(true);
              const authData = AuthData.getAuthData();
              const url = `${authData.appFunctionUrl}${SETTINGS_API}/emails?code=${authData.azureFunctionKey}`; // Use the constant here
              const response = await Fetch(url, authData.clientId);
              setMails(response);

              setModified(false); // Reset modified state after fetching
              
    } catch (err) {
      setError("Failed to load mailing list");
      setLoader(false);
    }finally{
      setLoader(false);
    }
    
  };

  const handleEmailChange = (e) => {
    setNewEmail(e.target.value);
    setModified(true);
  };

  const addEmailHandler = async (e) => {
    e.preventDefault();
    
    if (newEmail && !newEmail.includes('@')) {
      setError("Please enter a valid email address");
      return;
    }

    // Check if email already exists in the mails array
    if (mails && mails.includes(newEmail)) {
      setError("This email address is already in the notification list");
      return;
    }
    
    try {
      setLoader(true);
      const authData = AuthData.getAuthData();

      const url = `${authData.appFunctionUrl}${SETTINGS_API}/emails?code=${authData.azureFunctionKey}`; // Use the constant here

      let emails = [...mails, newEmail]; // Create a new array with the new email added
      const response = await Post(url,authData.clientId, emails); // Assuming `save` is the method in postService

      setMails(response);
      setError(null); // Clear any previous error
      setSuccessTimer(10); // Reset timer to 10 seconds
               // Start countdown timer
              const timerInterval = setInterval(() => {
              setSuccessTimer((prev) => {
                  if (prev <= 1) {
                      clearInterval(timerInterval); // Clear timer when it reaches 0
                      setSuccess(false); // Hide success message
                      return 0;
                  }
                  return prev - 1;
              });
          }, 1000);
    } catch (err) {
      setError("Failed to add email to mailing list");
      setLoader(false);
    }finally{
      setSuccess(true);
      setLoader(false);
      setNewEmail(''); // Clear the input field after successful addition
    }
    
  };

  const handleYes = () => {
    // Reset functionality
    setNewEmail('');
    setModified(true);
    setShowPopup(false);
    setError(null); 
  };
  
  const handleNo = () => {
    setShowPopup(false);
  };

  return (
    <div className="container" style={{ position: 'relative' }}>
      {loader && <RelativeSvgLoader />}
      <div className="form-wrapper" style={{ opacity: loader ? 0.3 : 1 }}>
        {error && <Error message={error} />}
        {success && <Success message={`Email added successfully! (${successTimer}s)`} />}
          
          <form onSubmit={addEmailHandler}>
            <div className="form-grid">
              <label htmlFor="mail" className="form-label">Notification email:</label>
                          <input
                              type="text"
                              id="mail"
                              name="mail"
                              onChange={handleEmailChange}
                              value={newEmail}
                              className="input-field"
                          />
                 
            </div>
                    <div className='form-footer'>
                            <button type="submit" disabled={!modified} className="submit-button">Save</button>
                            <button type="button" 
                                className='clear-data-button' 
                                style={{ marginLeft: '10px' }} onClick={() => setShowPopup(true)}>Reset</button>
                    </div>
          </form>
          
          {mails && mails.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',marginTop: '10px', gap: '12px' }}>
                                {mails.map((item, index) => (
                                    <SingleBadge
                                        key={index}
                                        name="Email"
                                        value={item}
                                        onRemove={() => {
                                            const updatedMails = mails.filter((_, idx) => idx !== index);
                                            setMails(updatedMails);
                                            setModified(true); // Set modified to true when an item is removed
                                        }}
                                    />
                                ))}
                            </div>
                        ) : (
                            <DataLine label="Mailing list" data="No items available." id="no-items" />
                        )}
        </div>
      {showPopup && (
        <YesNoPopup 
          handleYes={handleYes} 
          handleNo={handleNo}
        />
      )}
    </div>
  );
};

export default Notifications;